module.exports = function() {
  return new Worker(__webpack_public_path__ + "bf39f9b49975ab4fc46f.worker.js");
};